module.exports = __webpack_public_path__ + "static/media/hero-small.79161684.jpg";